module.exports = __webpack_public_path__ + "img/HybridMail.55ffcfcd.svg";